import { api } from "@/lib/api";

const CHUNK = 512 * 1024;

export function fileToRawB64(file) {
  return new Promise((res, rej) => {
    const fr = new FileReader();
    fr.onload = () => res(String(fr.result).split(",")[1] || "");
    fr.onerror = () => rej(new Error("Couldn't read that file."));
    fr.readAsDataURL(file);
  });
}

// Chunked base64 upload for video stories: init → chunk* → complete → { media_id }.
export async function uploadStoryVideo(file, onProgress) {
  const b64 = await fileToRawB64(file);
  const init = await api.storyUploadInit({ name: file.name, mime: file.type || "video/mp4", size: file.size });
  const uploadId = init?.upload_id || init?.id || init?.uploadId;
  if (!uploadId) throw new Error("Upload could not be started.");
  const total = Math.max(1, Math.ceil(b64.length / CHUNK));
  for (let i = 0; i < total; i++) {
    await api.storyUploadChunk({ upload_id: uploadId, index: i, data_b64: b64.slice(i * CHUNK, (i + 1) * CHUNK) });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const done = await api.storyUploadComplete(uploadId);
  return done?.media_id || done?.id || done?.mediaId;
}
